import { css } from "styled-components";

export const SPRIMARY = css`
  ${`14px`}
`;

export const XXsmall = css`
  ${`11px`}
`;

export const Xsmall = css`
  ${`12px`}
`;

export const SMALL = css`
  ${`13px`}
`;

export const MEDIUM = css`
  ${`15px`}
`;

export const XMEDIUM = css`
  ${`18px`}
`;

export const LARGE = css`
  ${`20px`}
`;
